import axios from "axios";
import { Base_URL } from "../url";

export const fetchPurchaseRequisitions = async () => {
  try {
    const response = await axios.get(`${Base_URL}/PurchaseRequisition/GetAllPurchaseRequisitions`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching purchase requisitions!";
  }
};

export const downloadPurchaseRequisitionsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/PurchaseRequisition/DownloadPurchaseRequisitionsExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading purchase requisitions data!";
  }
};